module.exports = __webpack_public_path__ + "static/media/novomatic.5f7f3acc.png";